import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import {
  Typography,
  Container,
  Divider,
  Stack,
  IconButton,
  Link,
} from '@mui/material';
import TwitterIcon from '@mui/icons-material/Twitter';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import InstagramIcon from '@mui/icons-material/Instagram';
import { version } from '../../version';

export function AboutUsPage() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const navigateToSocialProfile = (url: string) => {
    window.open(url);
  };
  return (
    <Container>
      <Typography variant="h5">{t('ABOUT_US')}</Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        <Trans i18nKey="ABOUT_US_DESCRIPTION_1">
          <a href="https://www.hitiq.com">placeholder_text</a>
        </Trans>
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        <Trans i18nKey="ABOUT_US_DESCRIPTION_2" />
      </Typography>
      <Typography variant="body1" sx={{ mt: 1 }}>
        <Trans i18nKey="ABOUT_US_DESCRIPTION_3" />
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ mt: 1 }}>
        {t('ABOUT_US_STAY_IN_TOUCH')}
      </Typography>
      <Stack direction="row" alignItems="center">
        <IconButton
          aria-label={t('accessibility.TWITTER')}
          onClick={() => navigateToSocialProfile('https://twitter.com/hitiq')}
        >
          <TwitterIcon color="primary" fontSize="small" />
        </IconButton>
        <IconButton
          aria-label={t('accessibility.FACEBOOK')}
          onClick={() => navigateToSocialProfile('https://facebook.com/hitiq')}
        >
          <FacebookIcon color="primary" fontSize="small" />
        </IconButton>
        <IconButton
          aria-label={t('accessibility.LINKEDIN')}
          onClick={() =>
            navigateToSocialProfile('https://www.linkedin.com/company/hitiq/')
          }
        >
          <LinkedInIcon color="primary" fontSize="small" />
        </IconButton>
        <IconButton
          aria-label={t('accessibility.INSTAGRAM')}
          onClick={() =>
            navigateToSocialProfile('https://www.instagram.com/hitiq_/')
          }
        >
          <InstagramIcon color="primary" fontSize="small" />
        </IconButton>
      </Stack>
      <Divider sx={{ my: 2 }} />
      <Typography variant="h6" sx={{ my: 1 }}>
        {t('LEGAL')}
      </Typography>
      <Link
        href="https://www.hitiq.com/conneqt-terms-of-use"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('TERMS_OF_SERVICE')}
      </Link>
      <Typography variant="subtitle1" sx={{ my: 1 }}>
        {t('TERMS_OF_USE_CONTENT')}
      </Typography>
      <Link
        href="https://www.hitiq.com/privacy-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('PRIVACY_POLICY')}
      </Link>
      <Typography variant="subtitle1" sx={{ my: 1 }}>
        {t('ABOUT_US_PRIVACY_POLICY_DESC')}
      </Typography>
      <Link
        href="https://hitiq.com/cookie-policy"
        target="_blank"
        rel="noopener noreferrer"
      >
        {t('COOKIE_POLICY')}
      </Link>
      <Typography variant="subtitle1" sx={{ my: 1 }}>
        {t('ABOUT_US_COOKIE_POLICY_DESC')}
      </Typography>
      <Divider sx={{ my: 2 }} />
      <Typography variant="body1" sx={{ mt: 1 }}>
        {t('VERSION')} {version}
      </Typography>
      <Typography variant="body1" sx={{ my: 2 }}>
        {t('COPYRIGHT_3', { copyrightYear: currentYear })}
      </Typography>
    </Container>
  );
}
